/*
  getApiUrl.js
*/

/**
 * Returns an API url, using a root URL and a pathname.
 * 
 * If no root url is provided, use a relative URL.
 * 
 * Mainly used to join two URLs while removing double slashes.
 *
 * @param {String} rootUrl
 * @param {String} path
 * 
 * @returns {string} URL.
 */
export default function getApiUrl(rootUrl, path) {

  rootUrl = rootUrl || '';
  path = path || '';

  if (rootUrl.endsWith('/')) {
    rootUrl = rootUrl.slice(0, -1);
  }

  if (path.startsWith('/')) {
    path = path.slice(1);
  }
  
  return `${rootUrl}/${path}`;

}
